import { render } from "./ViewOrderModal.vue?vue&type=template&id=4e3518cc"
import script from "./ViewOrderModal.vue?vue&type=script&lang=js"
export * from "./ViewOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__